import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface IDeviceDetailsState {
    record: { [index: string]: any };
    visible: boolean;
}

const initialState: IDeviceDetailsState = {
    record: {},
    visible: false,
};

const deviceEnergyDetails = createSlice({
    name: 'deviceEnergyDetails',
    initialState,
    reducers: {
        deviceEnergyDetailsInit(state) {
            state.record = {};
            state.visible = false;
        },
        deviceEnergyDetailsOpen(state, action: PayloadAction<IDeviceDetailsState>) {
            const { record, visible } = action.payload;
            state.record = record;
            state.visible = visible;
        },
    },
});

export const { deviceEnergyDetailsInit, deviceEnergyDetailsOpen } = deviceEnergyDetails.actions;

export default deviceEnergyDetails.reducer;
